// global parameters
const Configuration = {
  VERSION: "1.1.37",
  // #33372, use this when params not loaded.
  DEFAULT_SYSOPTION: "S",
};

export default Configuration;
